import * as Paginator from "react-bootstrap-table2-paginator";

import { Card, Col, Form, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import ToolkitProvider, {
  CSVExport,
  Search,
} from "react-bootstrap-table2-toolkit";
import { faPlus, faSearch } from "@fortawesome/free-solid-svg-icons";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import {
  getUserEntry,
  getUserEntryByDate,
  getUserEntryExcelDownload,
  getUserEntryPdfDownload,
  getUserLExcel,
  putUserEntry,
} from "../../Service/AllUserEntryAPI";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Pagination from "react-bootstrap-table2-paginator";
import Table from "react-bootstrap-table-next";
import axios from "../../utils/axiosInstance";
import cellEditFactory from "react-bootstrap-table2-editor";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import fileSaver from "file-saver";
import moment from "moment";
import swal from "sweetalert";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

// import "./addressHover.css";

export default () => {
  const [entries, setEntries] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [type, setType] = useState("user");
  // ----- pagination
  const [state, setState] = useState({});
  const [currentPage, setcurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [totaloffset, setTotaloffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoaded, setisLoaded] = useState(false);
  const { SearchBar } = Search;
  const { ExportCSVButton } = CSVExport;
  const [changeRowData, setChangeRowData] = useState({
    selectedRow: [],
    cellChange: "",
    columnChange: [],
  });

  useEffect(() => {
    // ----- Function call to get user list
    getUserList();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    // ----- Function call to update user details
    putUserDetailsChange();
    // eslint-disable-next-line
  }, [changeRowData]);

  const handlePageChange = async (page) => {
    setEntries([]);
    const selectedPage = page - 1;
    console.log("selectedPage", selectedPage);
    if (fromDate === "" && toDate === "") {
      const role = sessionStorage.getItem("role");
      const fkUserId = sessionStorage.getItem("pkUserId");
      const token = sessionStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      //  setisLoaded(true);
      await getUserEntry(selectedPage, fkUserId, role, headers)
        .then((result) => {
          console.log("Get Pagination Dispatch Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            console.log("data", data);
            setEntries(data);
            setPageCount(result.data.totalPages);
            setTotaloffset(totalSize);
            entries.map((item, index) => (item.id = totalSize + index + 1));
            setisLoaded(false);
          } else {
            setisLoaded(false);
            swal("Sorry", "User Data is not present", "warning");
          }
        })
        .catch((error) => console.error("Error", error));
    }
    // ----- Date wise pagination
    else if (fromDate !== "" && toDate !== "") {
      //  setisLoaded(true);
      await getUserEntryByDate(
        selectedPage,
        moment(fromDate).format("yyyy-MM-DD"),
        moment(toDate).format("yyyy-MM-DD")
      )
        .then((result) => {
          console.log("Get Pagination Date wise Dealer Result", result);
          if (result?.data?.content?.length !== 0) {
            const data = result.data.content;
            const totalSize = result.data.pageable.offset;
            entries.map((item, index) => (item.id = totalSize + index + 1));
            setEntries(data);
            setTotaloffset(totalSize);
            setTotalCount(result.data.totalElements);
            setisLoaded(false);
          } else {
            setisLoaded(false);
            swal(
              "Sorry",
              "User data is not present for selected date.",
              "warning"
            );
          }
        })
        .catch((error) => {
          console.log("Get Field Issue Error", error);
        });
    } else {
      swal("Failed", "Please select date", "error");
    }
  };

  // ----- Function declaration of get user list
  const getUserList = async () => {
    try {
      setTimeout(async () => {
        setisLoaded(true);
        const role = sessionStorage.getItem("role");
        const fkUserId = sessionStorage.getItem("pkUserId");
        const token = sessionStorage.getItem("token");
        const headers = { Authorization: `Bearer ${token}` };
        await getUserEntry(currentPage, fkUserId, role, headers)
          .then((result) => {
            console.log("Get User Entry Result", result);
            if (result?.data?.content?.length !== 0) {
              const data = result.data.content;
              setEntries(data);
              setPageCount(result.data.totalPages);
              setTotalCount(result.data.totalElements);
            } else {
              swal("Sorry", "User data is not present.", "warning");
            }
          })
          .catch((error) => {
            console.log("Get User Entry Error", error);
          });
        setisLoaded(false);
      }, 200);
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };
// old code for from date and to date
  // // ----- Function declaration for setting fromDate on "fromDate" field change event
  // const getUserListByFromDate = (e) => {
  //   setFromDate(e.target.value);
  //   console.log("fromDate", fromDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };

  // // ----- Function declaration for setting toDate on "toDate" field change event
  // const getUserListByToDate = async (e) => {
  //   setToDate(e.target.value);
  //   console.log("toDate", toDate);
  //   if (e.target.value > new Date().toISOString().split("T")[0]) {
  //     swal("Sorry", "Please select today or day before today", "warning");
  //   }
  // };


  const handleFromDateChange = (date) => {
    setFromDate(date);
    // Clear the "To" date if it's before the selected "From" date
    if (toDate && date > toDate) {
      setToDate(null);
    }
  };

  const handleToDateChange = (date) => {
    if (date < fromDate) {
      swal('Invalid Date', 'The "To" date cannot be before the "From" date.', 'warning');
      setToDate(null); // Reset "To" date if invalid
    } else {
      setToDate(date);
    }
  };

  // ----- Function declaration for API call to get user list by date on "Search By Date" button click event
  const getUserListByDate = async () => {
    try {
      setTimeout(async () => {
        setisLoaded(true);
        if (fromDate !== "" && toDate !== "") {

          await getUserEntryByDate(
            currentPage,
            moment(fromDate).format("yyyy-MM-DD"),
            moment(toDate).format("yyyy-MM-DD")
          )
            .then((result) => {
              console.log("Get User Entry Result", result);
              if (result?.data?.content?.length !== 0) {
                const data = result.data.content;
                setEntries(data);
                setPageCount(result.data.totalPages);
                setTotalCount(result.data.totalElements);
                    setToDate("")
                setFromDate("")
              } else {
                setEntries([]);
                setPageCount();
                setTotalCount();

                swal(
                  "Sorry",
                  "User data is not present for selected date",
                  "warning"
                );
              }
              // console.log("setNoOfElements", noOfElements);
            })
            .catch((error) => {
              console.log("Get User Entry Error", error);
            });
        } else {
          swal("Failed", "Please select date", "error");
        }
        setisLoaded(false);
      }, 200);
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

  // ----- Function declaration to Download Users Pdf
  const getUserPdfDownload = async () => {
    try {
      // ----- Pdf by filtering date
      if (fromDate !== "" && toDate !== "") {
        setisLoaded(true);
        await getUserEntryPdfDownload(
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        );
        setisLoaded(false);
            setToDate("")
                setFromDate("")
      } else {
        setisLoaded(false);
        swal("Failed", "Please select date", "error");
      }
    } catch (error) {
      console.log(error);
      setisLoaded(false);
    }
  };

  // ----- Function declaration to Download Users Excel
  const getUserExcelDownload = async () => {
    if (fromDate !== "" && toDate !== "") {
      // ----- Excel by filtering date
      try {
        await getUserEntryExcelDownload(
          moment(fromDate).format("yyyy-MM-DD"),
          moment(toDate).format("yyyy-MM-DD")
        );
            setToDate("")
                setFromDate("")
      } catch (error) {
        console.log("getUserEntryExcelDownload error :-", error);
      }
    } else {
      // ----- complete Excel
      try {
        let token = sessionStorage.getItem("token");
        let fileType = ["Excel"];
        let headers = { Authorization: `Bearer ${token}` };
        let result = await getUserLExcel(fileType, headers);
        console.log("getUserLExcel result :-", result);
            setToDate("")
                setFromDate("")
        let blob = new Blob([result.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        fileSaver.saveAs(blob, "userList.xlsx");
      } catch (error) {
        console.log("getUserLExcel error :-", error);
      }
    }
  };

  // ----- Function declaration to update user details
  const putUserDetailsChange = async () => {
    try {
      if (changeRowData?.selectedRow?.length !== 0) {
        // ----- Set selectedRow to edited row getting from child component
        const selectedRow = changeRowData.selectedRow;
        // ----- Set selectedRow's edited column with edited new value getting from child component
        selectedRow[changeRowData.columnChange] = changeRowData.cellChange;
        console.log("Change User row", selectedRow);
        const loginUserName = sessionStorage.getItem("userName");
        const loginRole = sessionStorage.getItem("role");
        // ----- Object to update user data
        const data = {
          pkUserId: selectedRow.pkUserId,
          firstName: selectedRow.firstName,
          lastName: selectedRow.lastName,
          companyName: selectedRow.companyName,
          mobileNo: selectedRow.mobileNo,
          role: selectedRow.role,
          email: selectedRow.email,
          country: selectedRow.country,
          state: selectedRow.state,
          city: selectedRow.city,
          address: selectedRow.address,
          description: selectedRow.description,
          userName: selectedRow.userName,
          password: selectedRow.password,
          status: selectedRow.status,
          createdOn: selectedRow.createdOn,
          createdBy: selectedRow.createdBy,
          modifyBy: `${loginUserName}`,
        };
        console.log("Change User datails", data);
        await putUserEntry(data)
          .then((result) => {
            console.log("User Result", result);
          })
          .catch((error) => {
            console.log("User Error", error);
            swal(
              "Failed",
              // "Something went wrong please check your internet",
              "error"
            );
          });
      }
    } catch (error) {
      console.log(error);
      // swal( "Failed", "Something went wrong please check your internet", "error" );
    }
  };

  // ----- Adding SrNo column to list
  entries.map((item, index) => (item.id = totaloffset + index + 1));

  // ----- Column heading of User list
  const columns = [
    { dataField: "id", text: "Sr. No." },
    {
      dataField: "firstName",
      text: "First Name",
      headerAlign: "left",
    },
    {
      dataField: "lastName",
      text: "Last Name",
      headerAlign: "left",
    },
    {
      dataField: "createdOn",
      text: "Created Date",
      headerAlign: "left",
      formatter: (cell) => {
        return <>{moment(cell).format("DD-MMM-YYYY")}</>;
      },
    },
    {
      dataField: "createdTime",
      text: "Created Time",
      formatter: (cell) => {
        const formattedTime = moment(cell, "hh:mm A", true);
        if (!formattedTime.isValid()) {
          return <>{'Invalid Time'}</>;
        }
        return <>{formattedTime.format("hh:mm A")}</>;
      },

    },
    {
      dataField: "companyName",
      text: "Company Name",
      headerAlign: "left",
    },
    {
      dataField: "role",
      text: "Designation",
      headerAlign: "left",
    },
     {
      dataField: "deparment",
      text: "deparment",
      headerAlign: "left",
    },
    // {

    //   // dataField: "jobCategory",
    //    dataField: "role",
    //   text: "Job Category",
    //   headerAlign: "left",
    //   formatter: (cell) => (!cell ? "NA" : cell),
    // },
    {
      dataField: "userName",
      text: "Username",
      headerAlign: "left",
    },
    {
      dataField: "email",
      text: "User Email",
      headerAlign: "left",
    },
    {
      dataField: "mobileNo",
      text: "Mobile No.",
      headerAlign: "left",
    },
    {
      dataField: "description",
      text: "Description",
      headerAlign: "left",
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell.length > 20 && (
            <span className="tooltip-text">{row.description}</span>
          )}
        </div>
      )
    },

    {
      dataField: "address",
      text: "Address",
      headerAlign: "left",
      formatter: (cell, row) => (
        <div className="tooltip-container">
          <div className="truncated-text">{cell}</div>
          {cell.length > 20 && (
            <span className="tooltip-text">{row.address}</span>
          )}
        </div>
      )
    },
    {
      dataField: "country",
      text: "Country",
      headerAlign: "left",
    },
    {
      dataField: "state",
      text: "State",
      headerAlign: "left",
    },
    {
      dataField: "city",
      text: "City",
      headerAlign: "left",
    },
    
   
  ];

  // ----- No. of Records to be displayed
  const customTotal = (from, to, size) => (
    <div>
      Showing {totaloffset + from} to {totaloffset + to} of {size} entries
    </div>
  );

  return (
    <>
      {isLoaded ? (
        <div className="reportload"></div>
      ) : (
        <>
          <Row>
            <Col md={{ span: 3, order: 1 }} className="mb-3" xs={{ order: 2 }}>
              <div className="form-group">
                 <label>From Date</label>
                <DatePicker
                  selected={fromDate}
                  onChange={handleFromDateChange}
                  dateFormat="dd-MMM-yyyy" 
                  maxDate={new Date()} 
                  className="form-control"
                  placeholderText="DD-MMM-YYYY"
                  showYearDropdown 
                  scrollableYearDropdown 
                />
              </div>
            </Col>
            <Col md={{ span: 3, order: 2 }} className="mb-3" xs={{ order: 3 }}>
              <div className="form-group">
              <label>To Date</label>
                <DatePicker
                  selected={toDate}
                  onChange={handleToDateChange}
                  dateFormat="dd-MMM-yyyy" 
                  minDate={fromDate} 
                  maxDate={new Date()} 
                  className="form-control"
                  placeholderText="DD-MMM-YYYY"
                  showYearDropdown 
                  scrollableYearDropdown 
                />
              </div>
            </Col>
            <Col md={{ span: 3, order: 3 }} className="mb-3" xs={{ order: 4 }}>
              <button
                className="btn btn-secondary mt-lg-4"
                onClick={getUserListByDate}
              >
                <FontAwesomeIcon icon={faSearch} className="me-2" />
                <span>Search By Date</span>{" "}
              </button>
            </Col>
            <Col md={{ span: 3, order: 4 }} className="mt-4" xs={{ order: 1 }}>
              <div className="newadd" align="right">
                <Link to="user-entry" className="btn btn-secondary">
                  <FontAwesomeIcon icon={faPlus} className="me-2" />
                  <span>Add User Entry</span>{" "}
                </Link>
              </div>
            </Col>
          </Row>

          <ToolkitProvider
            keyField="id"
            search={true}
            columns={columns}
            data={entries}
            exportCSV={{ onlyExportFiltered: true, exportAll: true }}
          >
            {({ baseProps, searchProps, csvProps }) => (
              <Paginator.PaginationProvider
                pagination={Pagination({
                  custom: true,
                  disablePageTitle: true,
                  alwaysShowAllBtns: true,
                  totalSize: totalCount,
                  paginationTotalRenderer: customTotal,
                  onPageChange: handlePageChange,
                  // sizePerPageRenderer: customSizePerPage,
                })}
              >
                {({ paginationProps, paginationTableProps }) => (
                  <Card>
                    <div className="table-responsive py-2">
                      <Card.Header>
                        <Row>
                           <Col xs={12} md={6} className="py-1">
                                                   <h5 className="head mb-2">User Entry list</h5></Col>
                          <Col
                            xs={12}
                            md={6}
                            className="d-flex justify-content-md-end py-1"
                          >
                            <button
                              className="btn btn-secondary"
                              // ----- Function call to download user pdf
                              onClick={getUserPdfDownload}
                            >
                              <FontAwesomeIcon
                                icon={faDownload}
                                className="me-2"
                              />
                              <span>PDF</span>{" "}
                            </button>
                            <button
                              className="btn btn-secondary mx-2"
                              // ----- Function call to download user excel
                              onClick={getUserExcelDownload}
                            >
                              <FontAwesomeIcon
                                icon={faDownload}
                                className="me-2"
                              />
                              <span>Excel</span>
                            </button>
                          </Col>
                        </Row>
                      </Card.Header>
                      <Table
                        {...baseProps}
                        {...paginationTableProps}
                        bodyClasses="border-0"
                        rowClasses="border-bottom"
                        classes="table-flush dataTable-table"
                        wrapperClasses="table-responsive"
                        filter={filterFactory()}
                        headerClasses="header-class"
                        hover
                        striped
                        remote={{ pagination: true }}
                        condensed
                        cellEdit={cellEditFactory({
                          mode: "click",
                          blurToSave: true,
                          afterSaveCell: (oldValue, newValue, row, column) => {
                            const changeRowData = {
                              selectedRow: row,
                              cellChange: newValue,
                              columnChange: column,
                            };
                            var newRowData = JSON.parse(
                              JSON.stringify(changeRowData)
                            );
                            setChangeRowData(newRowData);
                            return { async: true };
                          },
                        })}
                      // selectRow={selectRow}
                      />
                      <Card.Footer>
                        <Row>
                          <Col
                            xs={12}
                            md={6}
                            className="d-flex align-items-center py-1"
                          ></Col>
                          <Col
                            xs={12}
                            md={6}
                            className="d-flex justify-content-md-end align-items-center mb-0 py-1"
                          >
                            <Paginator.PaginationListStandalone
                              {...paginationProps}
                            />
                          </Col>
                        </Row>
                      </Card.Footer>
                    </div>
                  </Card>
                )}
              </Paginator.PaginationProvider>
            )}
          </ToolkitProvider>
        </>
      )}
    </>
  );
};
